import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DialogDataService<T> {
    constructor() {}
    dialogAlias: string;
    uniqueId: string;
    data: T;
}
